import { Language, Locale } from 'services/language-service';
import { CategoryDimensionType } from './MooringArticleCategory';
import { CertificateProducer } from './MooringSupplier';
import { CertificateSendType } from 'components/dialogs/send-certificates-choice/send-certificates-choice-dialog';

export enum MooringCertificateReliabilityClass {
  II = 2,
  III = 3,
}
export class MooringCertificate {
  static ApiUrl = 'api/mooring-certificates';
  Id: number;

  ArticleProductId: number;
  ArticleProduct: {
    ProductName: string;
    ArticleNumber: string;
    ProductId: number;
    MooringArticleId: number;
  };

  ApprovedBy?: string;
  ApprovedById?: string;
  ApprovedAt?: Date;

  SupplierId: number;
  SupplierName: string;

  BatchNumber: string;
  BatchNumberTo: string;

  InternalOrderNumber?: string;

  DateOfGoodsReceipt?: Date;

  Quantity?: number;

  Inactive: boolean;

  MooringStationId: number;

  TemplateId?: number;

  ReliabilityClass: MooringCertificateReliabilityClass;

  ProducerDocumentationAttachmentId?: number;
  CertificateAttachmentId?: number;

  DocumentationAttachmentIds?: number[];

  Certificates: {
    AttachmentId: number;
    Locale: Locale;
  }[];

  OverrideCertificateProducer?: CertificateProducer;
}

export class CreateUpdateMooringCertificate {
  Id?: number;

  SupplierId: number;
  BatchNumber: string;
  BatchNumberTo: string;

  InternalOrderNumber?: string;

  DateOfGoodsReceipt?: Date;

  Quantity?: number;
  ReliabilityClass: MooringCertificateReliabilityClass;

  TemplateId?: number;
  CertificateAttachment?: File;

  DocumentationAttachments?: File[];
  RemoveDocumentationAttachmentIds?: number[];

  OverrideCertificateProducer?: CertificateProducer;
}

export class MooringCertificateListItem {
  Id: number;

  ApprovedAt?: Date;

  ArticleProductId: number;

  SupplierName: string;
  SupplierId: number;

  CertificateProducer: CertificateProducer;

  Certificates: {
    AttachmentId: number;
    Locale: Locale;
  }[];

  CategoryName: string;
  CategoryId: number;

  TypeName: string;
  TypeId: number;

  ProductTypeName?: string;
  ProductTypeId?: number;

  ErpSystemName: string;
  ArticleNo: string;
  ProductName: string;

  BatchNumber: string;
  BatchNumberTo: string;

  InternalOrderNumber?: string;

  DateOfGoodsReceipt?: Date;
  ReliabilityClass: MooringCertificateReliabilityClass;

  Quantity?: number;

  PrimaryDimension: number;
  PrimaryDimensionType: CategoryDimensionType;

  SecondaryDimension?: number;
  SecondaryDimensionType?: CategoryDimensionType;

  OverrideCertificateProducer?: CertificateProducer;
}

export class MooringFrameCertificateListItem {
  Id: number;

  ApprovedAt?: Date;
  ArticleProductId: number;
  OrderId: number;
  CertificateNumber: string;
  CustomerName?: string;
  CustomerId?: number;
  LocalityName?: string;
  LocalityId?: number;
  MooringStationName: string;
}

export class CheckDuplicateMooringCertificate {
  ArticleProductId: number;
  BatchNumber: string;
}

export enum MooringCertificateRecipientType {
  Me = 0,
  CustomEmail = 1,
}

export class SendMooringCertificates {
  CertificateIds: number[] = [];
  SendType: CertificateSendType = CertificateSendType.Zip;
  RecipientType: MooringCertificateRecipientType = MooringCertificateRecipientType.Me;
  RecipientEmail?: string;
}

export class SentToEmailHistory {
  Date: Date;
  UserName: string;
  SentToEmail: string;
  Locale: string;
}
